<div class="ng-progress-line"
     [class.ng-progress-line-visible]="isShow"
     [class.ng-progress-line-scroll-down]="isScrollDown">
    <div class="ng-progress" [style.width.%]="progressWidth" [style.transition]="progressTransition"></div>
</div>
